import { Locale } from 'modules/i18n';

export const promoGreetingTranslation = {
  [Locale.en]: {
    invitationToActivate: 'Activate to start.',
    invitationToSignIn: 'Sign in to activate.',
  },
};
